import React from 'react';
import { bemClasses } from '../helpers';
export var TreeSpace = function () { return (React.createElement("span", { className: bemClasses.element("tree-space") })); };
export var TreeLeaf = function () { return (React.createElement("span", { className: bemClasses.element("tree-leaf") })); };
//# sourceMappingURL=Tree.js.map